import HttpClient from "./axios-helper/HttpClient";

export const getContractDetails = async (contractData) => {
    let headers = {
        'Content-Type': "application/json;",
    }

    try {
        const res = await HttpClient.get(`GetContractDetails`, headers, contractData);
        return res;
    } catch (e) {
        return e;
    }
};

export const getDocuments = async (obj) => {
    let headers = {
        'Content-Type': "application/json;",
        'Authorization': localStorage.getItem('gcp-token')
    }

    try {
        const res = await HttpClient.get(`GetDocuments`, headers, obj);
        return res;
    } catch (e) {
        if (e.response != null && e.response.status === 401) {
            window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
        }
        return e;
    }
}

export const getAttachment = async (obj) => {
    let headers = {
        'Content-Type': "application/json;",
        'Authorization': localStorage.getItem('gcp-token')
    }

    try {
        const res = await HttpClient.getAttachment(`GetAttachment`, headers, obj);
        return res;
    } catch (e) {
        if (e.response != null && e.response.status === 401) {
            window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
        }
        return e;
    }
}

export const postDocument = async (claim_number, direction, identifier, dataObj) => {
    let headers = {
        'Content-Type': "application/json;",
        'Authorization': localStorage.getItem('gcp-token')
    }
    try {
        const url = 'PostAttachment?claim_number=' + claim_number + "&direction=" + direction + "&identifier=" + identifier;
        const res = await HttpClient.post(url, dataObj, headers);
        return res;
    } catch (e) {
        if (e.response != null && e.response.status === 401) {
            window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
        }
        return e;
    }
}

export const getSeaDocument = async(fileUrl) => {
    let headers = {
        'Content-Type': "application/json;",
        'Access-Control-Allow-Origin': '*'
    }
    try {
        const res = await HttpClient.getAttachment(fileUrl, headers);
        return res;
    } catch (e) {
        if (e.response != null && e.response.status === 401) {
            window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
        }
        return e;
    }
}

export const createNote = async (claim_number, note_text) => {
    let headers = {
        'Content-Type': "application/json;",
        'Authorization': localStorage.getItem('gcp-token')
    }
    try {
        const url = 'CreateNotes?claimId=' + claim_number + "&noteText=" + note_text;
        const res = await HttpClient.post(url, "",headers);
        return res;
    } catch (e) {
        if (e.response != null && e.response.status === 401) {
            window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
        }
        return e;
    }
}